<template>
	<div class="tooltip-wrap">
		<div
			class="tooltip-trigger"
			@click="openTooltip"
			:class="{ hidden: isActive }"
		>
			<slot name="trigger">
				<i class="icon-info-circle"></i>
			</slot>
		</div>

		<transition name="tooltip-show">
			<div
				ref="tooltip"
				id="tooltip"
				class="tooltip d-none d-md-block"
				v-if="isActive"
				v-click-outside="closeTooltip"
			>
				<div
					class="tooltip__title"
					v-if="$slots.title"
				>
					<slot name="title"></slot>
				</div>
				<div class="tooltip__content"><slot></slot></div>
				<button
					class="btn-close"
					@click="closeTooltip"
				></button>
			</div>
		</transition>

		<Popup
			v-model="isActive"
			width="440"
			class="tooltip_mobile d-md-none"
			tooltipMode
		>
			<div
				class="tooltip__title"
				v-if="$slots.title"
			>
				<slot name="title"></slot>
			</div>
			<div class="tooltip__content"><slot></slot></div>

			<template #outside>
				<transition name="popup-btn">
					<button
						v-show="isActive"
						class="tooltip__ok-btn btn-primary"
						@click="closeTooltip"
					>
						{{ $t('excellent') }}!
					</button>
				</transition>
			</template>
		</Popup>
	</div>
</template>

<script>
import Popup from '@/components/Popup'

export default {
	components: {
		Popup,
	},

	watch: {
		isActive(val) {
			if (val) {
				this.$nextTick(() => this.setTooltipPosition())
				window.addEventListener('resize', this.setTooltipPosition)
			} else window.removeEventListener('resize', this.setTooltipPosition)
		},
	},

	data() {
		return {
			isActive: false,
			offsetRight: 20,
			popupBreakpoint: 768,
		}
	},

	methods: {
		setTooltipPosition() {
			if (!this.isActive) return
			// Не допускаем, чтобы тултип выходил за пределы экрана:
			// Вычисляем расстояние до правого края:
			let windowWidth = document.body.clientWidth
			if (windowWidth < this.popupBreakpoint) return
			let tooltip = this.$refs.tooltip
			let width = tooltip.offsetWidth
			let right = 0
			let el = tooltip
			while (el && el.offsetParent) {
				right += el.offsetLeft
				el = el.offsetParent
			}
			right += el.offsetLeft
			right = windowWidth - right - width
			// Задаём смещение:
			let x = 0
			if (right < this.offsetRight) {
				if (right > 0) x = this.offsetRight - right
				else x = Math.abs(right) + this.offsetRight
			}
			tooltip.style.transform = `translateX(${-x}px)`
		},

		openTooltip($e) {
			if (!this.isActive) {
				this.isActive = true
				$e.stopPropagation()
			}
		},

		closeTooltip() {
			this.isActive = false
		},
	},
}
</script>

<style lang="scss">
@import '@/sass/_variables';

.tooltip-wrap {
	position: relative;
	display: inline-block;
}

.tooltip-trigger {
	cursor: pointer;
	opacity: 1;
	transition: 0.3s;
	font-size: 24px;
	color: #005bd2;
	&.hidden {
		opacity: 0;
		transform: scale(0.5);
	}
}

.tooltip {
	background: linear-gradient(
		90deg,
		rgba(102, 0, 204, 0.9) 5.34%,
		rgba(1, 51, 255, 0.9) 91.03%
	);
	backdrop-filter: blur(15px);
	border-radius: 14px;
	padding: 46px 63px;
	position: absolute;
	top: 0;
	left: 0;
	width: 440px;
	z-index: 10;
	&__title {
		margin-bottom: 18px;
		font-size: 16px;
		line-height: 24px;
		font-weight: 600;
	}
	&__content {
		font-size: 14px;
		letter-spacing: 0.2px;
	}
}

.tooltip_mobile {
	min-height: 340px;
	.tooltip__content {
		font-size: 12px;
	}
	.tooltip__ok-btn {
		margin-top: 8px;
		width: 440px;
	}
}

.popup-btn-enter,
.popup-btn-leave-active {
	opacity: 0;
	transform: scale(0.5) translateY(-70px);
}
.popup-btn-enter-active,
.popup-btn-leave-active {
	transition: 0.3s ease;
}

.tooltip-show-enter,
.tooltip-show-leave-active {
	opacity: 0;
	transform: scale(0.9) translate(-10%, -10%);
}
.tooltip-show-enter-active,
.tooltip-show-leave-active {
	transition: 0.25s ease;
}
</style>
